import pathOr from 'ramda/src/pathOr'
import allFieldsValuesSelector from 'root/src/client/logic/embedded/selectors/allFieldsValuesSelector'
import { TITLE_HEADER_MARKETPLACE_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

// TODO - potential bug cause. wth is this?
export const selectedTabSelector = state => pathOr(0, ['tab', 'id'], allFieldsValuesSelector(state, { moduleId: TITLE_HEADER_MARKETPLACE_MODULE_ID }))

export default (state, { moduleId }) => pathOr(0, ['tab', 'id'], allFieldsValuesSelector(state, { moduleId }))
